<template>
  <span>
    <!-- This is the Login Button -->
    <div id="email" @click.stop="displayDialog">
      <div v-if="user">
        {{ $store.state.user.langEng ? "LOG OUT" : "LOGGA UT" }}
      </div>
      <!-- <h4 v-if="user">{{ user.email[0].toUpperCase() || "?" }}</h4> -->
      <div v-else>{{ $store.state.user.langEng ? "LOG IN" : "LOGGA IN" }}</div>
    </div>

    <!-- This is the Login Dialog -->
    <div
      v-if="displayLoginDialog"
      id="login-display"
      class="container z-depth-2"
    >
      <div class="cancel-button right-align">
        <i class="material-icons small" @click="displayLoginDialog = false"
          >cancel</i
        >
      </div>
      <div class="row">
        <form class="col s12 center">
          <div class="input-field inline">
            <input
              type="email"
              class="validate"
              v-if="displayLoginDialog"
              v-model="inputEmail"
              name="email"
              @keyup.enter="performLogin"
              placeholder=" E-mail"
            />
            <span
              class="helper-text"
              data-error="wrong input"
              data-success="correct input"
            ></span>
          </div>

          <div class="input-field inline">
            <input
              v-model="inputPassword"
              type="password"
              name="password"
              @keyup.enter="performLogin"
              required
              :placeholder="$store.state.user.langEng ? 'Password' : 'Lösenord'"
            />
          </div>
          <span
            class="helper-text"
            data-error="wrong"
            data-success="right"
          ></span>
        </form>
      </div>
      <div class="center red-text">
        <p v-if="errorMessage">
          <strong>{{ errorMessage }}</strong>
        </p>
        <a
          class="waves-effect waves-light btn-small right"
          @click="performLogin"
        >
          {{ $store.state.user.langEng ? "Login" : "Logga in" }}
        </a>
      </div>
    </div>

    <!-- This is the Logout Dialog -->
    <div v-if="displayLogoutDialog" id="logout-display" class="z-depth-2">
      <div class="cancel-button right-align" v-if="!forcedToChangePassword">
        <i class="material-icons small" @click="displayLogoutDialog = false"
          >cancel</i
        >
      </div>
      <div class="container center-align">
        <div class="row">
          <div class="col">
            <ul>
              <a
                class="waves-effect waves-light black-text btn-flat change-password-button"
                @click="
                  displayChangePasswordDialog = true;
                  displayLogoutDialog = false;
                "
              >
                {{
                  $store.state.user.langEng ? "Change password" : "Byt lösenord"
                }}
              </a>
            </ul>

            <ul>
              <a
                class="waves-effect waves-light btn-small"
                @click="performLogout"
              >
                {{ $store.state.user.langEng ? "Logout" : "Logga ut" }}
              </a>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- This is the Change Password Dialog -->
    <div
      v-if="displayChangePasswordDialog"
      id="password-change-display"
      class="z-depth-2"
    >
      <div>
        <div class="cancel-button right-align" v-if="!forcedToChangePassword">
          <i
            class="material-icons small"
            @click="displayChangePasswordDialog = false"
            >cancel</i
          >
        </div>

        <span v-if="forcedToChangePassword">{{
          $store.state.user.langEng
            ? "You must set a new password"
            : "Du måste byta lösenord"
        }}</span>
        <h6 v-else>
          {{
            $store.state.user.langEng ? "Set new password:" : "Byt lösenord:"
          }}
        </h6>
        <div>
          <form>
            <p class="red--text" v-if="errorMessage">
              <strong>{{ errorMessage }}</strong>
            </p>
            <div class="input-field">
              <input
                type="password"
                :placeholder="
                  $store.state.user.langEng
                    ? 'Current password'
                    : 'Nuvarande lösenord'
                "
                v-model="inputPassword"
                name="old-password"
                :class="{ 'error-outline': oldPasswordError }"
                required
              />
            </div>
            <div class="input-field">
              <input
                :placeholder="
                  $store.state.user.langEng ? 'New Password' : 'Ny Lösenord'
                "
                v-model="newPassword"
                type="password"
                name="new-password"
                :class="{ 'error-outline': newPasswordError }"
                required
              />
            </div>
            <div class="input-field">
              <input
                :placeholder="
                  $store.state.user.langEng
                    ? 'Repeat password'
                    : 'Repetera lösenordet'
                "
                v-model="newPassword2"
                type="password"
                name="new-password-2"
                :class="{ 'error-outline': newPasswordError2 }"
                required
              />
            </div>
          </form>
          <p class="mb-0 mt-5">
            {{
              $store.state.user.langEng
                ? "Your new password must contain:"
                : "Ditt lösenord måste innehålla:"
            }}
          </p>
          <ul>
            <li v-html="rule1text" :class="{ 'red--text': !rule1 }"></li>
            <li v-html="rule2text" :class="{ 'red--text': !rule2 }"></li>
            <li v-html="rule3text" :class="{ 'red--text': !rule3 }"></li>
            <li v-html="rule4text" :class="{ 'red--text': !rule4 }"></li>
            <li v-html="rule5text" :class="{ 'red--text': !rule5 }"></li>
            <li class="red--text" v-if="!rule6">
              <i v-html="rule6text"></i>
            </li>
          </ul>
        </div>
        <div class="center">
          <a
            v-if="forcedToChangePassword"
            class="waves-effect waves-light btn-small"
            @click="performLogout"
          >
            {{ $store.state.user.langEng ? "Logout" : "Logga ut" }}
          </a>
          <a
            class="waves-effect waves-light btn-small set-password-button"
            @click="changePassword"
          >
            {{ $store.state.user.langEng ? "Set password" : "Byt lösenord" }}
          </a>
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { colors, errMsg } from "@/utils";

@Component
export default class ProfileDialog extends Vue {
  displayLoginDialog = false;
  displayLogoutDialog = false;
  displayChangePasswordDialog = false;
  inputEmail = this.loadFromLocalStorage("email");
  inputPassword = "";
  newPassword = "";
  newPassword2 = "";
  oldPasswordError = false;
  newPasswordError = false;
  newPasswordError2 = false;
  errorMessage = "";
  forcedToChangePassword = false;
  languagePlaceholder = this.$store.state.user.langEng
    ? "Password"
    : "Lösenord";

  get rule1() {
    return this.newPassword.match(/[A-ZÅÄÖ]/);
  }
  get rule2() {
    return this.newPassword.match(/[a-zåäö]/);
  }
  get rule3() {
    return this.newPassword.replace(/[åäöÅÄÖ0-9]/g, "").match(/\W/);
  }
  get rule4() {
    return this.newPassword.match(/\d/);
  }
  get rule5() {
    return this.newPassword.length >= 9 && this.newPassword.length <= 48;
  }
  get rule6() {
    return !this.newPassword.startsWith("$2b$10$");
  }

  get rule1text() {
    return this.$store.state.user.langEng
      ? "At least 1 <strong>UPPERCASE</strong> letter"
      : "Minst 1 <strong>STOR</strong> bokstav";
  }
  get rule2text() {
    return this.$store.state.user.langEng
      ? "At least 1 <strong>lowercase</strong> letter"
      : "Minst 1 <strong>liten</strong> bokstav";
  }
  get rule3text() {
    return this.$store.state.user.langEng
      ? "At least 1 <strong>symbol</strong> (#%&/!_ etc)"
      : "Minst 1 <strong>symbol</strong> (#%&/!_ etc).";
  }
  get rule4text() {
    return this.$store.state.user.langEng
      ? "At least 1 <strong>number</strong>"
      : "Minst 1 <strong>siffra</strong>";
  }
  get rule5text() {
    return this.$store.state.user.langEng
      ? "Length of <strong>9-48</strong> characters."
      : "Mellan <strong>9-48</strong> tecken långt.";
  }
  get rule6text() {
    return this.$store.state.user.langEng
      ? "Your password may not begin with these 7 characters..."
      : "Ditt lösenord får ej börja på dessa 7 tecken...";
  }

  get user() {
    return this.$store.state.user.loggedInUser;
  }

  get iconColor() {
    let randomColor = Math.round(Math.random() * colors.length);
    return colors[randomColor];
  }

  @Watch("inputPassword")
  watchOldPassword() {
    this.oldPasswordError = this.inputPassword.length < 5;
  }

  @Watch("newPassword")
  watchNewPassword() {
    const totalRules = [
      this.rule1,
      this.rule2,
      this.rule3,
      this.rule4,
      this.rule5,
      this.rule6,
    ];
    const validRules = totalRules.filter((r) => !!r);

    this.newPasswordError = validRules.length !== totalRules.length;
    this.newPasswordError2 = this.newPassword !== this.newPassword2;
    this.oldPasswordError = this.inputPassword.length < 5;
  }

  @Watch("newPassword2")
  watchNewPassword2() {
    this.newPasswordError2 = this.newPassword !== this.newPassword2;
  }

  beforeCreate() {
    this.$store.dispatch("whoami").then((result) => {
      if (!result && this.inputEmail && this.inputPassword) {
        this.performLogin();
      } else if (result) {
        this.checkBadPassword();
      }
    });
  }

  displayDialog() {
    if (this.user) this.displayLogoutDialog = true;
    else this.displayLoginDialog = true;
  }

  async checkBadPassword() {
    let { oldPasswordIsBad } = await this.$store.dispatch("mustChangePassword");
    if (oldPasswordIsBad) {
      this.forcedToChangePassword = true;
      this.displayChangePasswordDialog = true;
    }
  }

  async performLogin() {
    this.errorMessage = "";
    this.inputEmail = this.inputEmail.toLowerCase().trim();
    if (!this.inputEmail || !this.inputPassword) {
      return;
    }
    localStorage.setItem("email", this.inputEmail);
    await this.$store.dispatch("login", {
      email: this.inputEmail,
      password: this.inputPassword,
    });
    if (this.user) {
      this.displayLoginDialog = false;
      this.inputPassword = "";
      this.checkBadPassword();
    } else if (this.displayLoginDialog) {
      this.errorMessage = this.newPassword
        ? "Failed to login"
        : "Inloggningen misslyckades";
    }
  }

  async changePassword() {
    this.errorMessage = "";
    this.watchNewPassword();
    if (this.newPasswordError || this.newPasswordError2) {
      return;
    }
    const result = await this.$store.dispatch("changePassword", {
      oldPassword: this.inputPassword,
      newPassword: this.newPassword,
    });
    this.inputPassword = "";
    if (result) {
      this.displayChangePasswordDialog = false;
      this.newPassword = "";
      this.newPassword2 = "";
      this.$store.commit("toggleSnackbar", {
        text: this.$store.state.user.langEng
          ? "Password changed!"
          : "Lösenord ändrat!",
      });
    } else if (errMsg) {
      if (errMsg == "Current password does not match.") {
        this.errorMessage = this.$store.state.user.langEng
          ? errMsg
          : "Det nuvarande lösenordet stämmer ej";
        this.oldPasswordError = true;
      }
    }
  }

  performLogout() {
    this.displayChangePasswordDialog = false;
    this.displayLogoutDialog = false;
    this.$store.dispatch("logout");
    this.inputPassword = "";
  }

  loadFromLocalStorage(key) {
    let s = localStorage.getItem(key);
    return s != null ? s : "";
  }
}
</script>

<style scoped lang="scss">
#email {
  font-size: 1em;
  font-weight: bold;
  color: white;
  text-shadow: 0px 0px 3px #000000;
  cursor: pointer;
}

#login-display {
  background-color: rgb(255, 255, 255);
  z-index: 45;
  position: fixed;
  margin-right: 2em;
  right: -0.5em;
  border-radius: 5px;
  padding: 20px;
}

#logout-display {
  background-color: rgb(255, 255, 255);
  z-index: 45;
  position: fixed;
  margin-right: 2em;
  right: -0.5em;
  border-radius: 5px;
  padding: 20px;
}

#password-change-display {
  background-color: rgb(255, 255, 255);
  z-index: 45;
  position: fixed;
  margin-right: 2em;
  right: -0.5em;
  border-radius: 5px;
  padding: 20px;
  max-width: 300px;
}

.input-field {
  background-color: rgb(255, 255, 255);
  margin: 8px !important;
  border-bottom: 1px solid black;
}
.input {
  border-bottom: 1px solid black !important;
}

.btn-small {
  margin: 4px;
  color: #ffffff;
  background-color: rgb(0, 0, 0);
  border-radius: 5px;
}
.row {
  margin-bottom: 0;
}
.helper-text {
  min-height: 0;
}
.cancel-button {
  color: black;
  cursor: pointer;
  padding: 0;
  margin-top: 4px;
}
.red-text {
  margin: 1em;
}
.container {
  max-width: 30vw;
}
.change-password-button {
  padding: 0;
}
.set-password-button {
  margin-top: 2em;
}
ul {
  padding: 0;
}
a:hover {
  text-decoration: underline;
}

@media (max-width: 992px) {
  .container {
    max-width: 45vw;
  }
}

@media (max-width: 600px) {
  .container {
    max-width: 70vw;
  }
}
</style>
